/**
 * Formats a time difference in seconds into a timer value string "HH:MM:SS".
 *
 * @param {number} seconds - The positive time difference in seconds (float value)
 * @returns {string} The timer in "HH:MM:SS" format.
 */
export const formatSecondsToTimer = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const numberPadding = (value: number) => String(value).padStart(2, '0');

  return `${numberPadding(hours)}:${numberPadding(minutes)}:${numberPadding(remainingSeconds)}`;
};
